module.exports = __webpack_public_path__ + "static/media/corporate-services-img76.a372648b.jpg";